import * as React from 'react';
import Paper from '@mui/material/Paper';
const styles = require('./styles.pcss');
import cx from 'classnames';

type CustomFieldResponse = {
  id: string;
  name: string;
  value?: string;
  isRequired?: boolean;
};

type Props = {
  customFieldResponses: CustomFieldResponse[];
  onCLickEdit: Function;
};

const AdditionalBookingDetails = (props: Props) => {
  const fields = props.customFieldResponses ?? [];

  return (
    <Paper
      className={cx(styles.bookingAdditionalDetails, styles.bookingDetails)}
    >
      <div className={styles.header}>
        <h1 className={styles.additionalDetailsTitle}>
          Additional Booking Details
        </h1>
      </div>
      <div className={styles.additionalBookingContainer}>
        <div className={styles.customFieldsList}>
          <div className={styles.subTitle}>Custom Fields:</div>
          {fields.length === 0 && (
            <div className={styles.customFieldEmpty}>No custom fields</div>
          )}
          {fields.map((field: CustomFieldResponse) => (
            <div
              key={field.id}
              className={styles.customFieldRow}
            >
              <span className={styles.customFieldName}>
                {field.name}
              </span>
              <span className={styles.customFieldValue}>
                {field.value || '—'}
              </span>
            </div>
          ))}
        </div>
        <div
          className={styles.editButton}
          onClick={() => props.onCLickEdit()}
        >
          Edit
        </div>
      </div>
    </Paper>
  );
};

export default AdditionalBookingDetails;
